// Core
import { useState } from 'react';
import {
  useRouteMatch,
  useLocation,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';

// Chakra imports
import { Box, Text, useColorModeValue } from '@chakra-ui/react';

// Components
import General from './components';
import { filterDate } from 'services/Utils';
import DashboardLayout from './components/DashboardLayout';
import useAccessibleEndpointsByGroups from '../../../hooks/useAccessibleEndpointsByGroups';
import FuelPrices from './components/FuelPrices';

function Dashboard({ tabEndpoints }) {
  const { path } = useRouteMatch();
  const textColor = useColorModeValue('blue.800', 'white');

  const [filterButtonLabel, setFilterButtonLabel] = useState('Last 3 Month');

  const currentDate = new Date();
  const threeMonthsAgo = new Date(currentDate);
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
  const [startDate, setStartDate] = useState(threeMonthsAgo);
  const [endDate, setEndDate] = useState(null);

  const handleGraph = (dates, type) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    if (type === 'picker') {
      setFilterButtonLabel('Custom period');
    }
  };

  const availableTabs = useAccessibleEndpointsByGroups(tabEndpoints);

  return (
    <>
      <Text
        fontSize="40px"
        fontStyle="normal"
        fontWeight="700"
        color={textColor}
        mb="12px"
      >
        Dashboard
      </Text>

      <Box>
        <Switch>
          <Route exact path={[`${path}/general`, `${path}`]}>
            <DashboardLayout availableTabs={availableTabs}>
              <Switch>
                {availableTabs.includes('/general') && (
                  <Route
                    path={`${path}/general`}
                    exact
                    component={() => (
                      <Box mt="0px" mb="50px" direction="column">
                        <General
                          startDate={startDate}
                          endDate={endDate}
                          period={filterButtonLabel}
                        />
                      </Box>
                    )}
                  />
                )}
                {availableTabs.includes('/') && (
                  <Route path={`${path}`} exact component={FuelPrices} />
                )}
              </Switch>
            </DashboardLayout>
          </Route>

          <Redirect from={`${path}*`} to={`${path}${availableTabs[0]}`} />
        </Switch>
      </Box>
    </>
  );
}

export default Dashboard;
